import { createPostEndpoint } from '@sonar-software/sonar-http';

export type SalesforceUpdateableMetadata = {
	complianceCategory: number;
	dataSensitivityLevelId: number;
	fieldUsageId: number;
	sonarObjectId: number;
};

export type PostSonarObjectSalesforceUpdateableRequest = {
	sonarObjectIds: Array<number>;
};

export type PostSonarObjectSalesforceUpdateableResponse = Array<SalesforceUpdateableMetadata>;

export const postSonarObjectSalesforceUpdateable = createPostEndpoint<
	PostSonarObjectSalesforceUpdateableRequest,
	PostSonarObjectSalesforceUpdateableResponse
>('/api/v3/salesforce/fields/metadata/salesforce-updateable');
